import styled from '@emotion/styled';
import {
  centered,
  row,
  column,
  itemColumn,
  itemRow,
} from 'styles/layout';

export const Centered = styled.div`
  ${centered};
`;

export const Row = styled.div`
  ${row};
`;

export const Column = styled.div`
  ${column};
`;

export const ItemColumn = styled.div`
  ${itemColumn};
`;

export const ItemRow = styled.div`
  ${itemRow};
`;
